









import { Component, Vue, Prop } from "vue-property-decorator";
import { isExternal } from "@/utils/validate";

@Component
export default class Link extends Vue {
  @Prop({ required: true }) private to!: string;

  private isExternalLink(routePath: string) {
    return isExternal(routePath);
  }
}
